import { Alert } from '@/types/community/alert';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

export const alerts: Alert[] = [
  // Recent alerts (last few days)
  {
    id: 'ALT001',
    title: 'Power Outage',
    description: 'Scheduled maintenance causing power outage in Block A',
    type: 'maintenance',
    status: 'active',
    block: {
      id: 'BLOCK001',
      name: 'Block A'
    },
    startTime: getRelativeDate(-2, 20, 0),
    endTime: getRelativeDate(-2, 22, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT002',
    title: 'Pool Maintenance',
    description: 'Pool will be closed for cleaning and maintenance',
    type: 'maintenance',
    status: 'active',
    amenity: {
      id: 'AMENITY001',
      name: 'Swimming Pool'
    },
    startTime: getRelativeDate(-1, 8, 0),
    endTime: getRelativeDate(-1, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT003',
    title: 'Fire Alarm Test',
    description: 'Monthly fire alarm system test will be conducted',
    type: 'security',
    status: 'active',
    startTime: getRelativeDate(0, 10, 0),
    endTime: getRelativeDate(0, 11, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT004',
    title: 'Security Alert',
    description: 'Suspicious activity reported in parking area',
    type: 'security',
    status: 'active',
    startTime: getRelativeDate(-3, 22, 0),
    endTime: getRelativeDate(-2, 6, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT005',
    title: 'Elevator Maintenance',
    description: 'Elevator in Block C will be out of service for maintenance',
    type: 'maintenance',
    status: 'active',
    block: {
      id: 'BLOCK003',
      name: 'Block C'
    },
    startTime: getRelativeDate(1, 9, 0),
    endTime: getRelativeDate(1, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Past week alerts
  {
    id: 'ALT006',
    title: 'Water Supply Interruption',
    description: 'Water supply will be temporarily interrupted for pipe repairs',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK002',
      name: 'Block B'
    },
    startTime: getRelativeDate(-7, 14, 0),
    endTime: getRelativeDate(-7, 16, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT007',
    title: 'Internet Maintenance',
    description: 'Scheduled internet maintenance affecting all blocks',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-8, 2, 0),
    endTime: getRelativeDate(-8, 4, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT008',
    title: 'Parking Lot Cleaning',
    description: 'Parking lot will be cleaned and repainted',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-9, 6, 0),
    endTime: getRelativeDate(-9, 14, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT009',
    title: 'Gym Equipment Update',
    description: 'New gym equipment installation in progress',
    type: 'maintenance',
    status: 'resolved',
    amenity: {
      id: 'AMENITY002',
      name: 'Fitness Center'
    },
    startTime: getRelativeDate(-12, 8, 0),
    endTime: getRelativeDate(-10, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT010',
    title: 'Emergency Contact Update',
    description: 'Please update your emergency contact information',
    type: 'other',
    status: 'active',
    startTime: getRelativeDate(-5, 9, 0),
    endTime: getRelativeDate(8, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Past month alerts
  {
    id: 'ALT011',
    title: 'HVAC System Maintenance',
    description: 'Heating and cooling system maintenance in all blocks',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-15, 8, 0),
    endTime: getRelativeDate(-15, 16, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT012',
    title: 'Security Camera Installation',
    description: 'New security cameras being installed in common areas',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-18, 9, 0),
    endTime: getRelativeDate(-16, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT013',
    title: 'Weather Warning',
    description: 'Severe weather expected - secure outdoor items',
    type: 'weather',
    status: 'resolved',
    startTime: getRelativeDate(-20, 14, 0),
    endTime: getRelativeDate(-19, 8, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT014',
    title: 'Fire Safety Inspection',
    description: 'Annual fire safety inspection will be conducted',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-22, 10, 0),
    endTime: getRelativeDate(-22, 15, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT015',
    title: 'Roof Repairs',
    description: 'Emergency roof repairs in Block D',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK004',
      name: 'Block D'
    },
    startTime: getRelativeDate(-25, 7, 0),
    endTime: getRelativeDate(-23, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Older alerts
  {
    id: 'ALT016',
    title: 'Plumbing Emergency',
    description: 'Major plumbing issue in Block A basement',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK001',
      name: 'Block A'
    },
    startTime: getRelativeDate(-30, 6, 0),
    endTime: getRelativeDate(-29, 20, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT017',
    title: 'Unauthorized Vehicle',
    description: 'Unauthorized vehicle parked in resident spot',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-32, 16, 0),
    endTime: getRelativeDate(-31, 10, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT018',
    title: 'Gas Leak Detection',
    description: 'Gas leak detected in Block B - immediate evacuation',
    type: 'emergency',
    status: 'resolved',
    block: {
      id: 'BLOCK002',
      name: 'Block B'
    },
    startTime: getRelativeDate(-35, 19, 0),
    endTime: getRelativeDate(-35, 23, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT019',
    title: 'Community Meeting',
    description: 'Monthly community meeting in the clubhouse',
    type: 'other',
    status: 'resolved',
    startTime: getRelativeDate(-40, 18, 0),
    endTime: getRelativeDate(-40, 20, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT020',
    title: 'Annual Maintenance',
    description: 'Annual building maintenance and inspection',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-45, 8, 0),
    endTime: getRelativeDate(-43, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  }
]; 